/*
  Usage:

  1. Create an instance of the logger with a key.
  const logger = new DebugLogger('MY_KEY');

  2. To enable logging, set 'MY_KEY' in localStorage to a truthy value.
  (You can do this programmatically via `localStorage.setItem('MY_KEY', 'true')`)

  3. Use the logger as you would the console.
  logger.log("This is a log message");      // Output: "[MY_KEY] This is a log message"
  logger.error("This is an error message"); // Output: "[MY_KEY] This is an error message"
  logger.warn("This is a warning message"); // Output: "[MY_KEY] This is a warning message"
 */

/**
 * A logger that only logs when a key is set in localStorage.
 * @param {string} key The key to check in localStorage.
 * @returns {DebugLogger} A logger that only logs when a key is set in localStorage.
 */
class DebugLogger {
  private readonly key: string;

  constructor(key: string) {
    this.key = key;
  }

  log(...args: unknown[]) {
    if (localStorage?.getItem(this.key)) {
      // eslint-disable-next-line no-console
      console.log(`[${this.key}]`, ...args);
    }
  }

  error(...args: unknown[]) {
    if (localStorage?.getItem(this.key)) {
      // eslint-disable-next-line no-console
      console.error(`[${this.key}]`, ...args);
    }
  }

  warn(...args: unknown[]) {
    if (localStorage?.getItem(this.key)) {
      // eslint-disable-next-line no-console
      console.warn(`[${this.key}]`, ...args);
    }
  }
}

export default DebugLogger;
